import React from "react";
import { Route, Routes } from "react-router-dom";
import QualityChecklistExecutionIndex from "../module/QualityChecklistExecution/qualityChecklistExecutionIndex";
import QualityConfigurationIndex from "../module/QualityConfiguration/qualityConfigurationIndex";

function QualityModuleRoutes() {
  return (
    <Routes>
      <Route path="procedure/*" element={<QualityChecklistExecutionIndex />} />
      <Route path="configuration/*" element={<QualityConfigurationIndex />} />
    </Routes>
  );
}

export default QualityModuleRoutes;
